/*****************************************************************
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY *
 *****************************************************************/
import { IconTemplate, IconProps } from './templates/icon';
import { FC, SVGProps } from 'react';
import _AccountIcon from './svg/account.svg?react';
import _AdministrationIcon from './svg/administration.svg?react';
import _AppleIcon from './svg/apple.svg?react';
import _ApprovedIcon from './svg/approved.svg?react';
import _AppstoreIcon from './svg/appstore.svg?react';
import _ArrowBackwardIcon from './svg/arrow_backward.svg?react';
import _ArrowDownIcon from './svg/arrow_down.svg?react';
import _ArrowForwardIcon from './svg/arrow_forward.svg?react';
import _ArrowLeftSmallerIcon from './svg/arrow_left_smaller.svg?react';
import _ArrowLeftIcon from './svg/arrow_left.svg?react';
import _ArrowRaisedRightIcon from './svg/arrow_raised_right.svg?react';
import _ArrowRightSmallerIcon from './svg/arrow_right_smaller.svg?react';
import _ArrowRightIcon from './svg/arrow_right.svg?react';
import _ArrowUpIcon from './svg/arrow_up.svg?react';
import _AttachmentIcon from './svg/attachment.svg?react';
import _BackwardIcon from './svg/backward.svg?react';
import _BankChartIcon from './svg/bank_chart.svg?react';
import _BavIcon from './svg/bav.svg?react';
import _BenefitSetIcon from './svg/benefit_set.svg?react';
import _BenefitsIcon from './svg/benefits.svg?react';
import _BetreuungskostenIcon from './svg/betreuungskosten.svg?react';
import _BkvIcon from './svg/bkv.svg?react';
import _BrowserWebAddIcon from './svg/browser_web_add.svg?react';
import _BudgetIcon from './svg/budget.svg?react';
import _BusIcon from './svg/bus.svg?react';
import _CalculatorIcon from './svg/calculator.svg?react';
import _CalendarEditIcon from './svg/calendar_edit.svg?react';
import _CalendarScheduleIcon from './svg/calendar_schedule.svg?react';
import _CalendarShareArrowIcon from './svg/calendar_share_arrow.svg?react';
import _CalendarIcon from './svg/calendar.svg?react';
import _CarChargingCableIcon from './svg/car_charging_cable.svg?react';
import _CarChargingIcon from './svg/car_charging.svg?react';
import _CarFrontIcon from './svg/car_front.svg?react';
import _CarSideIcon from './svg/car_side.svg?react';
import _CashBanknoteCoinsIcon from './svg/cash_banknote_coins.svg?react';
import _CashBanknotePlusIcon from './svg/cash_banknote_plus.svg?react';
import _ChargingStationElectricityIcon from './svg/charging_station_electricity.svg?react';
import _ChartUpIcon from './svg/chart_up.svg?react';
import _ChartDiagramIcon from './svg/chart-diagram.svg?react';
import _ChatQuestionSupportIcon from './svg/Chat_Question_Support.svg?react';
import _ChatMessagesIcon from './svg/chat-messages.svg?react';
import _CheckmarkCircleFilledIcon from './svg/checkmark_circle_filled.svg?react';
import _CheckmarkCircleIcon from './svg/checkmark_circle.svg?react';
import _CheckmarkOutlinedIcon from './svg/checkmark_outlined.svg?react';
import _CheckmarkIcon from './svg/checkmark.svg?react';
import _ChefHatIcon from './svg/chef_hat.svg?react';
import _ChevronGrabberVerticalIcon from './svg/chevron_grabber_vertical.svg?react';
import _ChristmasGiftIcon from './svg/christmas_gift.svg?react';
import _CircleIcon from './svg/circle.svg?react';
import _ClockIcon from './svg/clock.svg?react';
import _CloseIcon from './svg/close.svg?react';
import _CoffeeIcon from './svg/coffee.svg?react';
import _CoinGrowthIcon from './svg/coin_growth.svg?react';
import _CoinGrowthOutlineIcon from './svg/coin_growth_outline.svg?react';
import _CompaniesIcon from './svg/companies.svg?react';
import _CompanySettingsIcon from './svg/company_settings.svg?react';
import _ContinueSquareIcon from './svg/continue-square.svg?react';
import _CopyIcon from './svg/copy.svg?react';
import _CreditcardIcon from './svg/creditcard.svg?react';
import _CrossIcon from './svg/cross.svg?react';
import _CrossCircleIcon from './svg/cross_circle.svg?react';
import _CsvIcon from './svg/csv.svg?react';
import _CursorClickSelectIcon from './svg/cursor_click_select.svg?react';
import _CustomBenefitHeartIcon from './svg/custom_benefit.svg?react';
import _DangerIcon from './svg/danger.svg?react';
import _DashboardIcon from './svg/dashboard.svg?react';
import _DeleteTrashIcon from './svg/delete_trash.svg?react';
import _DeleteIcon from './svg/delete.svg?react';
import _DisabledSquareIcon from './svg/disabled_square.svg?react';
import _DocumentCheckmarkIcon from './svg/document_checkmark.svg?react';
import _DocumentIcon from './svg/document.svg?react';
import _DotsMenuIcon from './svg/dots_menu.svg?react';
import _DownloadArrowIcon from './svg/download-arrow.svg?react';
import _DownloadIcon from './svg/download.svg?react';
import _DownloadBoxIcon from './svg/download_box.svg?react';
import _EditProfileIcon from './svg/edit_profile.svg?react';
import _EditIcon from './svg/edit.svg?react';
import _EmployeeCalculatingIcon from './svg/employee_calculating.svg?react';
import _EmployeeWaitingIcon from './svg/employee_waiting.svg?react';
import _EmployeesGraphicIcon from './svg/employees_graphic.svg?react';
import _EmployeesSquareIcon from './svg/employees-square.svg?react';
import _EmployingCompaniesIcon from './svg/employing_companies.svg?react';
import _EmptyTableIcon from './svg/empty-table.svg?react';
import _ErholungsbeihilfeIcon from './svg/erholungsbeihilfe.svg?react';
import _ErrorCircleFilledIcon from './svg/error_circle_filled.svg?react';
import _EssenzuschussIcon from './svg/essenzuschuss.svg?react';
import _ExcelImportIcon from './svg/excel_import.svg?react';
import _ExcelIcon from './svg/excel.svg?react';
import _ExchangeIcon from './svg/exchange.svg?react';
import _EyeClosedIcon from './svg/eye_closed.svg?react';
import _EyeOpenIcon from './svg/eye_open.svg?react';
import _EyesClosedIcon from './svg/eyes_closed.svg?react';
import _EyesOpenIcon from './svg/eyes_open.svg?react';
import _FahrtkostenIcon from './svg/fahrtkosten.svg?react';
import _FilterIcon from './svg/filter.svg?react';
import _FolderIcon from './svg/folder.svg?react';
import _FoodBasketIcon from './svg/food_basket.svg?react';
import _GesundheitsförderungIcon from './svg/gesundheitsförderung.svg?react';
import _HeadphonesSupportIcon from './svg/headphones_support.svg?react';
import _HealthGraphHeartIcon from './svg/health _graph _heart.svg?react';
import _HealthInsurancesIcon from './svg/health_insurances.svg?react';
import _HealthyDietFruitIcon from './svg/healthy_diet_fruit.svg?react';
import _HeartbeatHeartIcon from './svg/heartbeat_heart.svg?react';
import _HeartbeatIcon from './svg/heartbeat.svg?react';
import _HelpIcon from './svg/help.svg?react';
import _HelpdeskIcon from './svg/helpdesk.svg?react';
import _HomeIcon from './svg/home.svg?react';
import _HornIcon from './svg/horn.svg?react';
import _ImageIcon from './svg/image.svg?react';
import _IndeterminateIcon from './svg/indeterminate.svg?react';
import _InfoIcon from './svg/info.svg?react';
import _InternetpauschaleIcon from './svg/internetpauschale.svg?react';
import _InvalidCompanyValueIcon from './svg/invalid_company_value.svg?react';
import _JobbikeIcon from './svg/jobbike.svg?react';
import _LandMarkIcon from './svg/land_mark.svg?react';
import _LandlineIcon from './svg/landline.svg?react';
import _LanguageIcon from './svg/language.svg?react';
import _LaunchIcon from './svg/launch.svg?react';
import _LifebuoyIcon from './svg/lifebuoy.svg?react';
import _LightBulbIcon from './svg/light-bulb.svg?react';
import _LimitSquareIcon from './svg/limit_square.svg?react';
import _LinkShearIcon from './svg/link-shear.svg?react';
import _LockIcon from './svg/lock.svg?react';
import _LogoutIcon from './svg/logout.svg?react';
import _LotusIcon from './svg/lotus.svg?react';
import _MailIcon from './svg/mail.svg?react';
import _ManuellAnlegenIcon from './svg/manuell_anlegen.svg?react';
import _MinusIcon from './svg/minus.svg?react';
import _MobileCheckmarkCircleIcon from './svg/mobile_checkmark_circle.svg?react';
import _MobilePhoneIcon from './svg/mobile_phone.svg?react';
import _MppIcon from './svg/mpp.svg?react';
import _NewsPaperIcon from './svg/news_paper.svg?react';
import _NoteIcon from './svg/note.svg?react';
import _NotificationIcon from './svg/notification.svg?react';
import _ÖpnvIcon from './svg/öpnv.svg?react';
import _PauseSquareIcon from './svg/pause-square.svg?react';
import _PayrollIcon from './svg/payroll.svg?react';
import _PdfIcon from './svg/pdf.svg?react';
import _PercentIcon from './svg/percent.svg?react';
import _PeopleIcon from './svg/people.svg?react';
import _PersonIcon from './svg/person.svg?react';
import _PersonalDataIcon from './svg/personal_data.svg?react';
import _PhoneIcon from './svg/phone.svg?react';
import _PiggyBankIcon from './svg/piggy_bank.svg?react';
import _PlusIcon from './svg/plus.svg?react';
import _PrecedingValuesIcon from './svg/preceding_values.svg?react';
import _ProfileIcon from './svg/profile.svg?react';
import _ProfileCircleIcon from './svg/profile_circle.svg?react';
import _PuzzleIcon from './svg/puzzle.svg?react';
import _ReceiptsIcon from './svg/receipts.svg?react';
import _ReceptionBellIcon from './svg/reception_bell.svg?react';
import _RefreshIcon from './svg/refresh.svg?react';
import _ReportingIcon from './svg/reporting.svg?react';
import _ResetIcon from './svg/reset.svg?react';
import _RoomServiceIcon from './svg/room_service.svg?react';
import _SachbezugIcon from './svg/Sachbezug.svg?react';
import _SalaryIcon from './svg/salary.svg?react';
import _SaleDiscountPromotionIcon from './svg/sale_discount_promotion.svg?react';
import _SaleDiscountIcon from './svg/sale_discount.svg?react';
import _SaveIcon from './svg/save.svg?react';
import _ScooterIcon from './svg/scooter.svg?react';
import _ScrollArrowLeftIcon from './svg/scroll_arrow_left.svg?react';
import _ScrollArrowRightIcon from './svg/scroll_arrow_right.svg?react';
import _SearchIcon from './svg/search.svg?react';
import _SecurityDisabledIcon from './svg/security_disabled.svg?react';
import _SecurityIcon from './svg/security.svg?react';
import _SelectEmployeeIcon from './svg/select_employee.svg?react';
import _SendMessageIcon from './svg/send_message.svg?react';
import _ShareArrowIcon from './svg/share_arrow.svg?react';
import _SettingsIcon from './svg/settings.svg?react';
import _ShieldCheckmarkIcon from './svg/shield_checkmark.svg?react';
import _ShieldSquareIcon from './svg/shield_square.svg?react';
import _ShoppingBagIcon from './svg/shopping_bag.svg?react';
import _SingleUserLockIcon from './svg/Single User Lock.svg?react';
import _SingleUserWarningIcon from './svg/Single User Warning.svg?react';
import _SingleUserDiscountIcon from './svg/single_user_discount.svg?react';
import _SingleUserIcon from './svg/single-user.svg?react';
import _SmileyIcon from './svg/smiley.svg?react';
import _SneakersIcon from './svg/sneakers.svg?react';
import _SortArrowDownIcon from './svg/sort_arrow_down.svg?react';
import _SortArrowUpIcon from './svg/sort_arrow_up.svg?react';
import _SparklesIcon from './svg/sparkles.svg?react';
import _SpinnerIcon from './svg/spinner.svg?react';
import _StatusEditIcon from './svg/status_edit.svg?react';
import _StatusRejectedIcon from './svg/status_rejected.svg?react';
import _StatusSubmittedIcon from './svg/status_submitted.svg?react';
import _StatusSuccessIcon from './svg/status_success.svg?react';
import _StoreDiscountIcon from './svg/store_discount.svg?react';
import _SynchronizeIcon from './svg/synchronize.svg?react';
import _TaxIcon from './svg/tax.svg?react';
import _TelefonkostenIcon from './svg/telefonkosten.svg?react';
import _TimeCoinsIcon from './svg/time_coins.svg?react';
import _TimeManagementIcon from './svg/time_management.svg?react';
import _TrashSquareIcon from './svg/trash-square.svg?react';
import _TruckIcon from './svg/truck.svg?react';
import _TxtIcon from './svg/txt.svg?react';
import _UserDeleteIcon from './svg/user_delete.svg?react';
import _UserGroupIcon from './svg/user_group.svg?react';
import _UserHeartHealthIcon from './svg/user_heart_health.svg?react';
import _UserDisabledIcon from './svg/user-disabled.svg?react';
import _UsersSendMoneyIcon from './svg/users_send_money.svg?react';
import _VipIcon from './svg/vip.svg?react';
import _WalletIcon from './svg/wallet.svg?react';
import _WalletPlusIcon from './svg/wallet_plus.svg?react';
import _WarningIcon from './svg/warning.svg?react';
import _WerbekostenIcon from './svg/werbekosten.svg?react';
import _YinyangIcon from './svg/yinyang.svg?react';
import _ZipIcon from './svg/zip.svg?react';

export const AccountIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_AccountIcon {...props} />;
};

export const AccountIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_AccountIcon} {...props} />;
};

export const AdministrationIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_AdministrationIcon {...props} />;
};

export const AdministrationIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_AdministrationIcon} {...props} />;
};

export const AppleIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_AppleIcon {...props} />;
};

export const AppleIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_AppleIcon} {...props} />;
};

export const ApprovedIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ApprovedIcon {...props} />;
};

export const ApprovedIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ApprovedIcon} {...props} />;
};

export const AppstoreIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_AppstoreIcon {...props} />;
};

export const AppstoreIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_AppstoreIcon} {...props} />;
};

export const ArrowBackwardIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ArrowBackwardIcon {...props} />;
};

export const ArrowBackwardIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ArrowBackwardIcon} {...props} />;
};

export const ArrowDownIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ArrowDownIcon {...props} />;
};

export const ArrowDownIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ArrowDownIcon} {...props} />;
};

export const ArrowForwardIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ArrowForwardIcon {...props} />;
};

export const ArrowForwardIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ArrowForwardIcon} {...props} />;
};

export const ArrowLeftSmallerIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ArrowLeftSmallerIcon {...props} />;
};

export const ArrowLeftSmallerIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ArrowLeftSmallerIcon} {...props} />;
};

export const ArrowLeftIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ArrowLeftIcon {...props} />;
};

export const ArrowLeftIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ArrowLeftIcon} {...props} />;
};

export const ArrowRaisedRightIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ArrowRaisedRightIcon {...props} />;
};

export const ArrowRaisedRightIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ArrowRaisedRightIcon} {...props} />;
};

export const ArrowRightSmallerIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ArrowRightSmallerIcon {...props} />;
};

export const ArrowRightSmallerIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ArrowRightSmallerIcon} {...props} />;
};

export const ArrowRightIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ArrowRightIcon {...props} />;
};

export const ArrowRightIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ArrowRightIcon} {...props} />;
};

export const ArrowUpIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ArrowUpIcon {...props} />;
};

export const ArrowUpIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ArrowUpIcon} {...props} />;
};

export const AttachmentIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_AttachmentIcon {...props} />;
};

export const AttachmentIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_AttachmentIcon} {...props} />;
};

export const BackwardIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_BackwardIcon {...props} />;
};

export const BackwardIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_BackwardIcon} {...props} />;
};

export const BankChartIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_BankChartIcon {...props} />;
};

export const BankChartIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_BankChartIcon} {...props} />;
};

export const BavIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_BavIcon {...props} />;
};

export const BavIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_BavIcon} {...props} />;
};

export const BenefitSetIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_BenefitSetIcon {...props} />;
};

export const BenefitSetIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_BenefitSetIcon} {...props} />;
};

export const BenefitsIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_BenefitsIcon {...props} />;
};

export const BenefitsIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_BenefitsIcon} {...props} />;
};

export const BetreuungskostenIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_BetreuungskostenIcon {...props} />;
};

export const BetreuungskostenIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_BetreuungskostenIcon} {...props} />;
};

export const BkvIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_BkvIcon {...props} />;
};

export const BkvIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_BkvIcon} {...props} />;
};

export const BrowserWebAddIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_BrowserWebAddIcon {...props} />;
};

export const BrowserWebAddIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_BrowserWebAddIcon} {...props} />;
};

export const BudgetIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_BudgetIcon {...props} />;
};

export const BudgetIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_BudgetIcon} {...props} />;
};

export const BusIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_BusIcon {...props} />;
};

export const BusIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_BusIcon} {...props} />;
};

export const CalculatorIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CalculatorIcon {...props} />;
};

export const CalculatorIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CalculatorIcon} {...props} />;
};

export const CalendarEditIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CalendarEditIcon {...props} />;
};

export const CalendarEditIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CalendarEditIcon} {...props} />;
};

export const CalendarScheduleIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CalendarScheduleIcon {...props} />;
};

export const CalendarScheduleIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CalendarScheduleIcon} {...props} />;
};

export const CalendarShareArrowIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CalendarShareArrowIcon {...props} />;
};

export const CalendarShareArrowIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CalendarShareArrowIcon} {...props} />;
};

export const CalendarIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CalendarIcon {...props} />;
};

export const CalendarIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CalendarIcon} {...props} />;
};

export const CarChargingCableIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CarChargingCableIcon {...props} />;
};

export const CarChargingCableIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CarChargingCableIcon} {...props} />;
};

export const CarChargingIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CarChargingIcon {...props} />;
};

export const CarChargingIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CarChargingIcon} {...props} />;
};

export const CarFrontIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CarFrontIcon {...props} />;
};

export const CarFrontIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CarFrontIcon} {...props} />;
};

export const CarSideIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CarSideIcon {...props} />;
};

export const CarSideIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CarSideIcon} {...props} />;
};

export const CashBanknoteCoinsIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CashBanknoteCoinsIcon {...props} />;
};

export const CashBanknoteCoinsIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CashBanknoteCoinsIcon} {...props} />;
};

export const CashBanknotePlusIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CashBanknotePlusIcon {...props} />;
};

export const CashBanknotePlusIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CashBanknotePlusIcon} {...props} />;
};

export const ChargingStationElectricityIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ChargingStationElectricityIcon {...props} />;
};

export const ChargingStationElectricityIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ChargingStationElectricityIcon} {...props} />;
};

export const ChartUpIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ChartUpIcon {...props} />;
};

export const ChartUpIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ChartUpIcon} {...props} />;
};

export const ChartDiagramIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ChartDiagramIcon {...props} />;
};

export const ChartDiagramIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ChartDiagramIcon} {...props} />;
};

export const ChatQuestionSupportIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ChatQuestionSupportIcon {...props} />;
};

export const ChatQuestionSupportIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ChatQuestionSupportIcon} {...props} />;
};

export const ChatMessagesIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ChatMessagesIcon {...props} />;
};

export const ChatMessagesIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ChatMessagesIcon} {...props} />;
};

export const CheckmarkCircleFilledIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CheckmarkCircleFilledIcon {...props} />;
};

export const CheckmarkCircleFilledIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CheckmarkCircleFilledIcon} {...props} />;
};

export const CheckmarkCircleIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CheckmarkCircleIcon {...props} />;
};

export const CheckmarkCircleIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CheckmarkCircleIcon} {...props} />;
};

export const CheckmarkOutlinedIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CheckmarkOutlinedIcon {...props} />;
};

export const CheckmarkOutlinedIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CheckmarkOutlinedIcon} {...props} />;
};

export const CheckmarkIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CheckmarkIcon {...props} />;
};

export const CheckmarkIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CheckmarkIcon} {...props} />;
};

export const ChefHatIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ChefHatIcon {...props} />;
};

export const ChefHatIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ChefHatIcon} {...props} />;
};

export const ChevronGrabberVerticalIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ChevronGrabberVerticalIcon {...props} />;
};

export const ChevronGrabberVerticalIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ChevronGrabberVerticalIcon} {...props} />;
};

export const ChristmasGiftIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ChristmasGiftIcon {...props} />;
};

export const ChristmasGiftIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ChristmasGiftIcon} {...props} />;
};

export const CircleIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CircleIcon {...props} />;
};

export const CircleIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CircleIcon} {...props} />;
};

export const ClockIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ClockIcon {...props} />;
};

export const ClockIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ClockIcon} {...props} />;
};

export const CloseIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CloseIcon {...props} />;
};

export const CloseIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CloseIcon} {...props} />;
};

export const CoffeeIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CoffeeIcon {...props} />;
};

export const CoffeeIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CoffeeIcon} {...props} />;
};

export const CoinGrowthIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CoinGrowthIcon {...props} />;
};

export const CoinGrowthIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CoinGrowthIcon} {...props} />;
};

export const CoinGrowthOutlineIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CoinGrowthOutlineIcon {...props} />;
};

export const CoinGrowthOutlineIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CoinGrowthOutlineIcon} {...props} />;
};

export const CompaniesIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CompaniesIcon {...props} />;
};

export const CompaniesIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CompaniesIcon} {...props} />;
};

export const CompanySettingsIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CompanySettingsIcon {...props} />;
};

export const CompanySettingsIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CompanySettingsIcon} {...props} />;
};

export const ContinueSquareIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ContinueSquareIcon {...props} />;
};

export const ContinueSquareIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ContinueSquareIcon} {...props} />;
};

export const CopyIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CopyIcon {...props} />;
};

export const CopyIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CopyIcon} {...props} />;
};

export const CreditcardIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CreditcardIcon {...props} />;
};

export const CreditcardIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CreditcardIcon} {...props} />;
};

export const CrossCircleIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CrossCircleIcon {...props} />;
};

export const CrossCircleIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CrossCircleIcon} {...props} />;
};

export const CsvIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CsvIcon {...props} />;
};

export const CsvIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CsvIcon} {...props} />;
};

export const CursorClickSelectIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CursorClickSelectIcon {...props} />;
};

export const CursorClickSelectIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CursorClickSelectIcon} {...props} />;
};

export const CustomBenefitHeartIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_CustomBenefitHeartIcon {...props} />;
};

export const CustomBenefitHeartIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CustomBenefitHeartIcon} {...props} />;
};

export const DangerIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_DangerIcon {...props} />;
};

export const DangerIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_DangerIcon} {...props} />;
};

export const DashboardIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_DashboardIcon {...props} />;
};

export const DashboardIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_DashboardIcon} {...props} />;
};

export const DeleteTrashIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_DeleteTrashIcon {...props} />;
};

export const DeleteTrashIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_DeleteTrashIcon} {...props} />;
};

export const DeleteIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_DeleteIcon {...props} />;
};

export const DeleteIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_DeleteIcon} {...props} />;
};

export const DisabledSquareIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_DisabledSquareIcon {...props} />;
};

export const DisabledSquareIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_DisabledSquareIcon} {...props} />;
};

export const DocumentCheckmarkIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_DocumentCheckmarkIcon {...props} />;
};

export const DocumentCheckmarkIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_DocumentCheckmarkIcon} {...props} />;
};

export const DocumentIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_DocumentIcon {...props} />;
};

export const DocumentIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_DocumentIcon} {...props} />;
};

export const DotsMenuIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_DotsMenuIcon {...props} />;
};

export const DotsMenuIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_DotsMenuIcon} {...props} />;
};

export const DownloadArrowIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_DownloadArrowIcon {...props} />;
};

export const DownloadArrowIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_DownloadArrowIcon} {...props} />;
};

export const DownloadIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_DownloadIcon {...props} />;
};

export const DownloadIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_DownloadIcon} {...props} />;
};

export const DownloadBoxIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_DownloadBoxIcon {...props} />;
};

export const DownloadBoxIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_DownloadBoxIcon} {...props} />;
};

export const EditProfileIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_EditProfileIcon {...props} />;
};

export const EditProfileIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_EditProfileIcon} {...props} />;
};

export const EditIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_EditIcon {...props} />;
};

export const EditIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_EditIcon} {...props} />;
};

export const EmployeeCalculatingIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_EmployeeCalculatingIcon {...props} />;
};

export const EmployeeCalculatingIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_EmployeeCalculatingIcon} {...props} />;
};

export const EmployeeWaitingIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_EmployeeWaitingIcon {...props} />;
};

export const EmployeeWaitingIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_EmployeeWaitingIcon} {...props} />;
};

export const EmployeesGraphicIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_EmployeesGraphicIcon {...props} />;
};

export const EmployeesGraphicIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_EmployeesGraphicIcon} {...props} />;
};

export const EmployeesSquareIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_EmployeesSquareIcon {...props} />;
};

export const EmployeesSquareIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_EmployeesSquareIcon} {...props} />;
};

export const EmployingCompaniesIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_EmployingCompaniesIcon {...props} />;
};

export const EmployingCompaniesIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_EmployingCompaniesIcon} {...props} />;
};

export const EmptyTableIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_EmptyTableIcon {...props} />;
};

export const EmptyTableIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_EmptyTableIcon} {...props} />;
};

export const ErholungsbeihilfeIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ErholungsbeihilfeIcon {...props} />;
};

export const ErholungsbeihilfeIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ErholungsbeihilfeIcon} {...props} />;
};

export const ErrorCircleFilledIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ErrorCircleFilledIcon {...props} />;
};

export const ErrorCircleFilledIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ErrorCircleFilledIcon} {...props} />;
};

export const EssenzuschussIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_EssenzuschussIcon {...props} />;
};

export const EssenzuschussIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_EssenzuschussIcon} {...props} />;
};

export const ExcelImportIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ExcelImportIcon {...props} />;
};

export const ExcelImportIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ExcelImportIcon} {...props} />;
};

export const ExcelIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ExcelIcon {...props} />;
};

export const ExcelIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ExcelIcon} {...props} />;
};

export const ExchangeIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ExchangeIcon {...props} />;
};

export const ExchangeIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ExchangeIcon} {...props} />;
};

export const EyeClosedIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_EyeClosedIcon {...props} />;
};

export const EyeClosedIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_EyeClosedIcon} {...props} />;
};

export const EyeOpenIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_EyeOpenIcon {...props} />;
};

export const EyeOpenIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_EyeOpenIcon} {...props} />;
};

export const EyesClosedIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_EyesClosedIcon {...props} />;
};

export const EyesClosedIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_EyesClosedIcon} {...props} />;
};

export const EyesOpenIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_EyesOpenIcon {...props} />;
};

export const EyesOpenIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_EyesOpenIcon} {...props} />;
};

export const FahrtkostenIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_FahrtkostenIcon {...props} />;
};

export const FahrtkostenIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_FahrtkostenIcon} {...props} />;
};

export const FilterIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_FilterIcon {...props} />;
};

export const FilterIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_FilterIcon} {...props} />;
};

export const FolderIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_FolderIcon {...props} />;
};

export const FolderIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_FolderIcon} {...props} />;
};

export const FoodBasketIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_FoodBasketIcon {...props} />;
};

export const FoodBasketIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_FoodBasketIcon} {...props} />;
};

export const GesundheitsförderungIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_GesundheitsförderungIcon {...props} />;
};

export const GesundheitsförderungIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_GesundheitsförderungIcon} {...props} />;
};

export const HeadphonesSupportIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_HeadphonesSupportIcon {...props} />;
};

export const HeadphonesSupportIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_HeadphonesSupportIcon} {...props} />;
};

export const HealthGraphHeartIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_HealthGraphHeartIcon {...props} />;
};

export const HealthGraphHeartIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_HealthGraphHeartIcon} {...props} />;
};

export const HealthInsurancesIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_HealthInsurancesIcon {...props} />;
};

export const HealthInsurancesIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_HealthInsurancesIcon} {...props} />;
};

export const HealthyDietFruitIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_HealthyDietFruitIcon {...props} />;
};

export const HealthyDietFruitIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_HealthyDietFruitIcon} {...props} />;
};

export const HeartbeatHeartIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_HeartbeatHeartIcon {...props} />;
};

export const HeartbeatHeartIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_HeartbeatHeartIcon} {...props} />;
};

export const HeartbeatIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_HeartbeatIcon {...props} />;
};

export const HeartbeatIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_HeartbeatIcon} {...props} />;
};

export const HelpIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_HelpIcon {...props} />;
};

export const HelpIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_HelpIcon} {...props} />;
};

export const HelpdeskIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_HelpdeskIcon {...props} />;
};

export const HelpdeskIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_HelpdeskIcon} {...props} />;
};

export const HomeIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_HomeIcon {...props} />;
};

export const HomeIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_HomeIcon} {...props} />;
};

export const HornIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_HornIcon {...props} />;
};

export const HornIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_HornIcon} {...props} />;
};

export const ImageIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ImageIcon {...props} />;
};

export const ImageIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ImageIcon} {...props} />;
};

export const IndeterminateIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_IndeterminateIcon {...props} />;
};

export const IndeterminateIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_IndeterminateIcon} {...props} />;
};

export const InfoIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_InfoIcon {...props} />;
};

export const InfoIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_InfoIcon} {...props} />;
};

export const InternetpauschaleIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_InternetpauschaleIcon {...props} />;
};

export const InternetpauschaleIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_InternetpauschaleIcon} {...props} />;
};

export const InvalidCompanyValueIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_InvalidCompanyValueIcon {...props} />;
};

export const InvalidCompanyValueIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_InvalidCompanyValueIcon} {...props} />;
};

export const JobbikeIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_JobbikeIcon {...props} />;
};

export const JobbikeIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_JobbikeIcon} {...props} />;
};

export const LandMarkIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_LandMarkIcon {...props} />;
};

export const LandMarkIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_LandMarkIcon} {...props} />;
};

export const LandlineIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_LandlineIcon {...props} />;
};

export const LandlineIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_LandlineIcon} {...props} />;
};

export const LanguageIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_LanguageIcon {...props} />;
};

export const LanguageIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_LanguageIcon} {...props} />;
};

export const LaunchIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_LaunchIcon {...props} />;
};

export const LaunchIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_LaunchIcon} {...props} />;
};

export const LifebuoyIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_LifebuoyIcon {...props} />;
};

export const LifebuoyIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_LifebuoyIcon} {...props} />;
};

export const LightBulbIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_LightBulbIcon {...props} />;
};

export const LightBulbIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_LightBulbIcon} {...props} />;
};

export const LimitSquareIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_LimitSquareIcon {...props} />;
};

export const LimitSquareIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_LimitSquareIcon} {...props} />;
};

export const LinkShearIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_LinkShearIcon {...props} />;
};

export const LinkShearIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_LinkShearIcon} {...props} />;
};

export const LockIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_LockIcon {...props} />;
};

export const LockIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_LockIcon} {...props} />;
};

export const LogoutIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_LogoutIcon {...props} />;
};

export const LogoutIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_LogoutIcon} {...props} />;
};

export const LotusIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_LotusIcon {...props} />;
};

export const LotusIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_LotusIcon} {...props} />;
};

export const MailIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_MailIcon {...props} />;
};

export const MailIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_MailIcon} {...props} />;
};

export const ManuellAnlegenIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ManuellAnlegenIcon {...props} />;
};

export const ManuellAnlegenIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ManuellAnlegenIcon} {...props} />;
};

export const MinusIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_MinusIcon {...props} />;
};

export const MinusIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_MinusIcon} {...props} />;
};

export const MobileCheckmarkCircleIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_MobileCheckmarkCircleIcon {...props} />;
};

export const MobileCheckmarkCircleIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_MobileCheckmarkCircleIcon} {...props} />;
};

export const MobilePhoneIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_MobilePhoneIcon {...props} />;
};

export const MobilePhoneIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_MobilePhoneIcon} {...props} />;
};

export const MppIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_MppIcon {...props} />;
};

export const MppIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_MppIcon} {...props} />;
};

export const NewsPaperIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_NewsPaperIcon {...props} />;
};

export const NewsPaperIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_NewsPaperIcon} {...props} />;
};

export const NoteIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_NoteIcon {...props} />;
};

export const NoteIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_NoteIcon} {...props} />;
};

export const ÖpnvIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ÖpnvIcon {...props} />;
};

export const ÖpnvIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ÖpnvIcon} {...props} />;
};

export const PauseSquareIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_PauseSquareIcon {...props} />;
};

export const PauseSquareIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_PauseSquareIcon} {...props} />;
};

export const PayrollIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_PayrollIcon {...props} />;
};

export const PayrollIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_PayrollIcon} {...props} />;
};

export const PdfIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_PdfIcon {...props} />;
};

export const PdfIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_PdfIcon} {...props} />;
};

export const PercentIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_PercentIcon {...props} />;
};

export const PercentIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_PercentIcon} {...props} />;
};

export const PeopleIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_PeopleIcon {...props} />;
};

export const PeopleIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_PeopleIcon} {...props} />;
};

export const PersonIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_PersonIcon {...props} />;
};

export const PersonIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_PersonIcon} {...props} />;
};

export const PersonalDataIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_PersonalDataIcon {...props} />;
};

export const PersonalDataIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_PersonalDataIcon} {...props} />;
};

export const PhoneIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_PhoneIcon {...props} />;
};

export const PhoneIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_PhoneIcon} {...props} />;
};

export const PiggyBankIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_PiggyBankIcon {...props} />;
};

export const PiggyBankIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_PiggyBankIcon} {...props} />;
};

export const PlusIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_PlusIcon {...props} />;
};

export const PlusIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_PlusIcon} {...props} />;
};

export const PrecedingValuesIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_PrecedingValuesIcon {...props} />;
};

export const PrecedingValuesIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_PrecedingValuesIcon} {...props} />;
};

export const ProfileIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ProfileIcon {...props} />;
};

export const ProfileIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ProfileIcon} {...props} />;
};

export const PuzzleIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_PuzzleIcon {...props} />;
};

export const PuzzleIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_PuzzleIcon} {...props} />;
};

export const ReceiptsIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ReceiptsIcon {...props} />;
};

export const ReceiptsIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ReceiptsIcon} {...props} />;
};

export const ReceptionBellIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ReceptionBellIcon {...props} />;
};

export const ReceptionBellIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ReceptionBellIcon} {...props} />;
};

export const RefreshIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_RefreshIcon {...props} />;
};

export const RefreshIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_RefreshIcon} {...props} />;
};

export const ReportingIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ReportingIcon {...props} />;
};

export const ReportingIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ReportingIcon} {...props} />;
};

export const ResetIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ResetIcon {...props} />;
};

export const ResetIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ResetIcon} {...props} />;
};

export const RoomServiceIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_RoomServiceIcon {...props} />;
};

export const RoomServiceIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_RoomServiceIcon} {...props} />;
};

export const SachbezugIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SachbezugIcon {...props} />;
};

export const SachbezugIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SachbezugIcon} {...props} />;
};

export const SalaryIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SalaryIcon {...props} />;
};

export const SalaryIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SalaryIcon} {...props} />;
};

export const SaleDiscountPromotionIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SaleDiscountPromotionIcon {...props} />;
};

export const SaleDiscountPromotionIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SaleDiscountPromotionIcon} {...props} />;
};

export const SaleDiscountIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SaleDiscountIcon {...props} />;
};

export const SaleDiscountIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SaleDiscountIcon} {...props} />;
};

export const SaveIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SaveIcon {...props} />;
};

export const SaveIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SaveIcon} {...props} />;
};

export const ScooterIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ScooterIcon {...props} />;
};

export const ScooterIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ScooterIcon} {...props} />;
};

export const ScrollArrowLeftIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ScrollArrowLeftIcon {...props} />;
};

export const ScrollArrowLeftIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ScrollArrowLeftIcon} {...props} />;
};

export const ScrollArrowRightIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ScrollArrowRightIcon {...props} />;
};

export const ScrollArrowRightIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ScrollArrowRightIcon} {...props} />;
};

export const SearchIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SearchIcon {...props} />;
};

export const SearchIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SearchIcon} {...props} />;
};

export const SecurityDisabledIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SecurityDisabledIcon {...props} />;
};

export const SecurityDisabledIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SecurityDisabledIcon} {...props} />;
};

export const SecurityIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SecurityIcon {...props} />;
};

export const SecurityIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SecurityIcon} {...props} />;
};

export const SelectEmployeeIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SelectEmployeeIcon {...props} />;
};

export const SelectEmployeeIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SelectEmployeeIcon} {...props} />;
};

export const SendMessageIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SendMessageIcon {...props} />;
};

export const SendMessageIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SendMessageIcon} {...props} />;
};

export const ShareArrowIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ShareArrowIcon {...props} />;
};

export const ShareArrowIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ShareArrowIcon} {...props} />;
};

export const SettingsIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SettingsIcon {...props} />;
};

export const SettingsIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SettingsIcon} {...props} />;
};

export const ShieldCheckmarkIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ShieldCheckmarkIcon {...props} />;
};

export const ShieldCheckmarkIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ShieldCheckmarkIcon} {...props} />;
};

export const ShieldSquareIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ShieldSquareIcon {...props} />;
};

export const ShieldSquareIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ShieldSquareIcon} {...props} />;
};

export const ShoppingBagIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ShoppingBagIcon {...props} />;
};

export const ShoppingBagIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ShoppingBagIcon} {...props} />;
};

export const SingleUserLockIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SingleUserLockIcon {...props} />;
};

export const SingleUserLockIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SingleUserLockIcon} {...props} />;
};

export const SingleUserWarningIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SingleUserWarningIcon {...props} />;
};

export const SingleUserWarningIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SingleUserWarningIcon} {...props} />;
};

export const SingleUserDiscountIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SingleUserDiscountIcon {...props} />;
};

export const SingleUserDiscountIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SingleUserDiscountIcon} {...props} />;
};

export const SingleUserIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SingleUserIcon {...props} />;
};

export const SingleUserIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SingleUserIcon} {...props} />;
};

export const SmileyIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SmileyIcon {...props} />;
};

export const SmileyIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SmileyIcon} {...props} />;
};

export const SneakersIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SneakersIcon {...props} />;
};

export const SneakersIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SneakersIcon} {...props} />;
};

export const SortArrowDownIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SortArrowDownIcon {...props} />;
};

export const SortArrowDownIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SortArrowDownIcon} {...props} />;
};

export const SortArrowUpIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SortArrowUpIcon {...props} />;
};

export const SortArrowUpIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SortArrowUpIcon} {...props} />;
};

export const SparklesIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SparklesIcon {...props} />;
};

export const SparklesIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SparklesIcon} {...props} />;
};

export const SpinnerIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SpinnerIcon {...props} />;
};

export const SpinnerIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SpinnerIcon} {...props} />;
};

export const StatusEditIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_StatusEditIcon {...props} />;
};

export const StatusEditIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_StatusEditIcon} {...props} />;
};

export const StatusRejectedIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_StatusRejectedIcon {...props} />;
};

export const StatusRejectedIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_StatusRejectedIcon} {...props} />;
};

export const StatusSubmittedIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_StatusSubmittedIcon {...props} />;
};

export const StatusSubmittedIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_StatusSubmittedIcon} {...props} />;
};

export const StatusSuccessIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_StatusSuccessIcon {...props} />;
};

export const StatusSuccessIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_StatusSuccessIcon} {...props} />;
};

export const StoreDiscountIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_StoreDiscountIcon {...props} />;
};

export const StoreDiscountIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_StoreDiscountIcon} {...props} />;
};

export const SynchronizeIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_SynchronizeIcon {...props} />;
};

export const SynchronizeIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_SynchronizeIcon} {...props} />;
};

export const TaxIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_TaxIcon {...props} />;
};

export const TaxIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_TaxIcon} {...props} />;
};

export const TelefonkostenIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_TelefonkostenIcon {...props} />;
};

export const TelefonkostenIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_TelefonkostenIcon} {...props} />;
};

export const TimeCoinsIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_TimeCoinsIcon {...props} />;
};

export const TimeCoinsIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_TimeCoinsIcon} {...props} />;
};

export const TimeManagementIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_TimeManagementIcon {...props} />;
};

export const TimeManagementIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_TimeManagementIcon} {...props} />;
};

export const TrashSquareIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_TrashSquareIcon {...props} />;
};

export const TrashSquareIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_TrashSquareIcon} {...props} />;
};

export const TruckIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_TruckIcon {...props} />;
};

export const TruckIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_TruckIcon} {...props} />;
};

export const TxtIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_TxtIcon {...props} />;
};

export const TxtIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_TxtIcon} {...props} />;
};

export const UserDeleteIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_UserDeleteIcon {...props} />;
};

export const UserDeleteIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_UserDeleteIcon} {...props} />;
};

export const UserGroupIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_UserGroupIcon {...props} />;
};

export const UserGroupIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_UserGroupIcon} {...props} />;
};

export const UserHeartHealthIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_UserHeartHealthIcon {...props} />;
};

export const UserHeartHealthIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_UserHeartHealthIcon} {...props} />;
};

export const UserDisabledIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_UserDisabledIcon {...props} />;
};

export const UserDisabledIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_UserDisabledIcon} {...props} />;
};

export const UsersSendMoneyIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_UsersSendMoneyIcon {...props} />;
};

export const UsersSendMoneyIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_UsersSendMoneyIcon} {...props} />;
};

export const VipIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_VipIcon {...props} />;
};

export const VipIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_VipIcon} {...props} />;
};

export const WalletIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_WalletIcon {...props} />;
};

export const WalletIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_WalletIcon} {...props} />;
};

export const WalletPlusIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_WalletPlusIcon {...props} />;
};

export const WalletPlusIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_WalletPlusIcon} {...props} />;
};

export const WarningIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_WarningIcon {...props} />;
};

export const WarningIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_WarningIcon} {...props} />;
};

export const WerbekostenIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_WerbekostenIcon {...props} />;
};

export const WerbekostenIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_WerbekostenIcon} {...props} />;
};

export const YinyangIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_YinyangIcon {...props} />;
};

export const YinyangIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_YinyangIcon} {...props} />;
};

export const ZipIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => {
  return <_ZipIcon {...props} />;
};

export const ZipIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ZipIcon} {...props} />;
};

export const ProfileCircleIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_ProfileCircleIcon} {...props} />;
};

export const NotificationIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_NotificationIcon} {...props} />;
};

export const CrossIcon: FC<IconProps> = (props: IconProps) => {
  return <IconTemplate component={_CrossIcon} {...props} />;
};
